export default __webpack_public_path__ + "static/media/banner3.9b03d201.jpg";